module.exports = __webpack_public_path__ + "static/img/xiandianIcon.f83345b6.svg";